import React from 'react';
import moment from 'moment';
import { Tooltip } from 'antd';

interface MessageTooltipProps {
  message: {
    createdAt: number;
  };
  children: React.ReactNode;
}

const MessageTooltip = function ({
  message: { createdAt },
  children,
}: MessageTooltipProps) {
  return (
    <Tooltip title={moment(createdAt).format('HH:mm:ss')}>
      <span>{children}</span>
    </Tooltip>
  );
};

export default MessageTooltip;
